export const referencesData = [
  {
    title: "Design graphique",
    links: [
      { name: "AAAAA", url: "https://www.aaaaa-atelier.org" },
      { name: "Another Graphic", url: "https://anothergraphic.org" },
      { name: "Antoine Peltier", url: "https://antoinepeltier.com" },
      { name: "Clément Thoby", url: "https://clementthoby.com/Index-projects" },
      { name: "Elena Schlenker", url: "https://elanaschlenker.com" },
      { name: "Fabrication Maison", url: "https://www.fabricationmaison.fr" },
      { name: "Fisk", url: "https://fiskprojects.com" },
      { name: "Formes des luttes", url: "https://formesdesluttes.org" },
      { name: "Formes Vives", url: "https://www.formes-vives.org/images/" },
      { name: "Graphis", url: "https://graphis.com" },
      { name: "Jaune Sardine", url: "https://www.jaune-sardine.fr" },
      { name: "Les Briefs Créatifs", url: "https://lesbriefscreatifs.com" },
      {
        name: "Les produits de l'épicerie",
        url: "https://www.lesproduitsdelepicerie.org",
      },
      { name: "Malte Martin", url: "https://ecouter-pour-voir.net" },
      {
        name: "Melissa Castrillon",
        url: "https://www.melissacastrillon.co.uk",
      },
      { name: "My creative type", url: "https://mycreativetype.com" },
      {
        name: "Ne pas plier",
        url: "https://www.nepasplier.fr/internationale.htm",
      },
      { name: "Ne rougissez pas", url: "https://www.nerougissezpas.fr" },
      {
        name: "Nous Travaillons Ensemble",
        url: "https://www.noustravaillonsensemble.fr",
      },
      { name: "Olivier Garraud", url: "https://oliviergarraud.com" },
      { name: "Roberta Ungaro", url: "https://www.robertaungaro.com" },
      { name: "Sebastien Marchal", url: "https://sebastienmarchal.fr" },
      { name: "Soliman Lopez", url: "https://solimanlopez.com" },
      { name: "Theo Garnier-Greuez", url: "https://www.theogarniergreuez.fr" },
      { name: "Typru", url: "https://typru.fr" },
      { name: "Yinka Ilori", url: "https://yinkailori.com" },
    ],
  },
  {
    title: "Motion Design",
    links: [
      { name: "AC-bu", url: "https://www.instagram.com/acbu_official/" },
      { name: "Duolingo", url: "https://blog.duolingo.com/hub/design/" },
    ],
  },
  {
    title: "Typographie",
    links: [
      {
        name: "Bye Bye Binary",
        url: "https://typotheque.genderfluid.space/fr",
      },
      { name: "Fonts In Use", url: "https://fontsinuse.com" },

      {
        name: "Mattias Persson",
        url: "https://www.skyknowledge.com/perssonsscripts/",
      },
      { name: "Typewolf", url: "https://www.typewolf.com/" },
    ],
  },
  {
    title: "Web Design",
    links: [
      { name: "Digitization", url: "https://www.digitization.wiki/" },
      { name: "Henry Desroches", url: "https://henry.codes/?ref=lapaninja" },
      { name: "Windows 93", url: "https://www.windows93.net" },
      { name: "Jakenpopp", url: "http://jankenpopp.com" },
      { name: "Maeve", url: "https://maevechocolate.com/?ref=lapaninja" },
      { name: "Making Software", url: "https://www.makingsoftware.com" },
    ],
  },
  {
    title: "Édition",
    links: [
      { name: "Back Office - Revue", url: "http://www.revue-backoffice.com" },
      { name: "Éditions B42", url: "https://editions-b42.com" },
      { name: "Fishey Immersive", url: "https://fisheyeimmersive.com" },
      { name: "Fishey magazine", url: "https://fisheyemagazine.fr" },
      { name: "SPASS", url: "https://spassplaisir.com" },
    ],
  },
  {
    title: "Critique & Théorie du design",
    links: [
      { name: "Dominique Moulon", url: "https://www.dominiquemoulon.com/fr/" },
      { name: "Samuel Bianchini", url: "https://dispotheque.org/fr" },
      {
        name: "Donato Ricci",
        url: "https://medialab.sciencespo.fr/equipe/donato-ricci/",
      },
      {
        name: "Ludovic Duhem",
        url: "https://shs.cairn.info/publications-de-ludovic-duhem--680845?lang=fr",
      },
    ],
  },
  {
    title: "Culture",
    links: [
      { name: "Accès)s( cultures électroniques", url: "https://acces-s.org" },
      { name: "CNAP", url: "https://www.cnap.fr" },
      {
        name: "Théatre Public Montreuil",
        url: "https://theatrepublicmontreuil.com",
      },
      { name: "L'Autre Soie", url: "https://www.autresoie.com" },
      { name: "La Gaîté Lyrique", url: "https://www.gaite-lyrique.net" },
      { name: "Le CENTQUATRE-PARIS", url: "https://www.104.fr" },
      {
        name: "Les Ateliers de la ville de Marseille",
        url: "https://www.ateliersvilledemarseille.fr",
      },
      { name: "Magasins Généraux", url: "https://magasinsgeneraux.com" },
      {
        name: "Maison des arts, centre d'art contemporain de malakoff",
        url: "https://maisondesarts.malakoff.fr/2/accueil.htm",
      },
    ],
  },
  {
    title: "Festival",
    links: [
      {
        name: "Les Puces Typo - Campus Fonderie de l'Image",
        url: "https://www.campusfonderiedelimage.org/les-puces-typo/",
      },
      {
        name: "Media Art Design - Moulon - festival liste",
        url: "https://www.mediaartdesign.net/index.html",
      },
      { name: "Nemo - Biennale", url: "https://www.biennalenemo.fr" },
    ],
  },
  {
    title: "École & Laboratoire",
    links: [
      {
        name: "ANRT - Atelier National de Recherche Typographique",
        url: "https://anrt-nancy.fr/fr",
      },
      { name: "EnsadLab", url: "https://www.ensadlab.fr" },
      {
        name: "Ircam - l’Institut de recherche et coordination acoustique/musique",
        url: "https://www.ircam.fr",
      },
      { name: "Médialab Sciences Po", url: "https://medialab.sciencespo.fr" },
    ],
  },
];

export const ressourcesData = [
  {
    name: "Kit de survie du créatif",
    url: "https://kitdesurvie.metiers-graphiques.fr",
  },
  { name: "Mockup Maison", url: "https://mockup.maison" },
  { name: "Realtime Colors", url: "https://www.realtimecolors.com/" },
  { name: "Symbl", url: "https://symbl.cc/fr/" },
  { name: "Fontshare", url: "https://www.fontshare.com" },
  { name: "Uncut", url: "https://uncut.wtf" },
  { name: "205", url: "https://www.205.tf" },
  { name: "Same Energy", url: "https://same.energy" },
  { name: "Texture Labs", url: "https://texturelabs.org" },
  { name: "P5.js", url: "https://p5js.org" },
  { name: "Processing", url: "https://processing.org" },
  { name: "Touchdesigner", url: "https://derivative.ca" },
  { name: "Blender", url: "https://www.blender.org" },
  { name: "Unity", url: "https://unity.com/fr" },
  {
    name: "CSS Cheat Sheet",
    url: "https://nerdcave.com/tailwind-cheat-sheet?ref=bestwebsite.gallery",
  },
  { name: "Artivive", url: "https://www.artivive.com" },
  { name: "M3 Material", url: "https://m3.material.io" },
];
